import { axios_requer, axios_export } from "../axios/http_axios";

// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let hasSing = true; //需要签名的加上这个
let method = "GET"; //需要GET请求的加上这个
let headerType = "json"; //需要JSON格式的加上这个

export default {
  //根据配置类型获取用户定制参数信息
  async getUserCustomizedConfInfo(params) {
    return await axios_requer({
      path: "/v1/admin/customized/getUserCustomizedConfInfo",
      params,
      method,
    }).then((res) => res);
  },
  //用户定制参数配置
  async addUserCustomizedConf(params) {
    return await axios_requer({
      path: "/v1/admin/customized/addUserCustomizedConf",
      params,
      hasSing,
    }).then((res) => res);
  },
  //异常列表-修改异常
  async updateException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/updateException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改客户报价(仅展示版)
  async updateCustomerOffer(params) {
    return await axios_requer({
      path: "/admin/v5/tms/customer/updateCustomerOffer",
      params,
      headerType,
    }).then((res) => res);
  },
  // 新增客户报价(仅展示版)
  async addCustomerOffer(params) {
    return await axios_requer({
      path: "/admin/v5/tms/customer/addCustomerOffer",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取租户logo图片
  async sumVolumeWeight(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/sumVolumeWeight",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取租户logo图片
  async getSystemVI(params) {
    return await axios_requer({
      path: "/admin/systemvi/getSystemVI",
      params,
      method,
    }).then((res) => res);
  },
  // 保存logo图片
  async updateSystemVI(params) {
    return await axios_requer({
      path: "/admin/systemvi/updateSystemVI",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 获取logo图片
  async logoInfo(params) {
    return await axios_requer({
      path: "/v1/admin/Logo/logoInfo",
      params,
      method,
    }).then((res) => res);
  },
  // 添加logo
  async addLogo(params) {
    return await axios_requer({
      path: "/v1/admin/Logo/addLogo",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 获取第三方平台信息(承运商)
  async getThirdApiPlatform(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/getThirdApiPlatform",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 保存第三方平台信息 (承运商)
  async savaThirdApiPlatform(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/savaThirdApiPlatform",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },

  // 拉取第三方平台单据数据
  async pullThirdApiPlatformData(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/pullThirdApiPlatformData",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取蓝桥单号类型下拉列表
  async getOnoTypeList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/getOnoTypeList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取报销单打印数据
  async getExpensePrintData(params) {
    return await axios_requer({
      path: "v3/admin/print/data/getExpensePrintData",
      params,
      headerType,
    }).then((res) => res);
  },
  // 修改运单财务应付信息
  async updateWaybillFinanceOut(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybillFinanceOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 获取运单发车批次应付财务信息
  async getWaybillOutgoingFinance(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillOutgoingFinance",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单发车批次应付财务信息
  async getWaybillDispatchFinance(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillDispatchFinance",
      params,
      method,
    }).then((res) => res);
  },
  // 取消签收
  async cancelSignforWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/cancelSignforWaybill",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 获取荣祥运单打印数据
  async getWaybillSignforInfo(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillSignforInfo",
      params,
      method,
    }).then((res) => res);
  },
  // 获取荣祥运单打印数据
  async getWaybillRxPrintData(params) {
    return await axios_requer({
      path: "/v3/admin/print/data/getWaybillRxPrintData",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取运输跟踪图片
  async billWeightCalculationById(params) {
    return await axios_requer({
      path: "/common/v2/formula/billWeightCalculationById",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取运输跟踪图片
  async getTrackTransportPics(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/getTrackTransportPics",
      params,
      headerType,
    }).then((res) => res);
  },

  // 运费计算(自定义选择报价)
  async freightCalculationById(params) {
    return await axios_requer({
      path: "/common/v2/formula/freightCalculationById",
      params,
    }).then((res) => res);
  },
  // 运费计算(获取报价方式)
  async freightCalculation(params) {
    return await axios_requer({
      path: "/common/v2/formula/freightCalculation",
      params,
    }).then((res) => res);
  },
  // 计费重量计算
  async billWeightCalculation(params) {
    return await axios_requer({
      path: "/common/v2/formula/billWeightCalculation",
      params,
      method,
    }).then((res) => res);
  },
  // 修改运单财务信息-过账
  async updateWaybillFinance(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybillFinance",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 批量过账
  async batchPostingWaybill(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/batchPostingWaybill",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 下载文件
  async wtl_downFile(params) {
    return await axios_export({
      path: "/base/saas/v1/file/downFile",
      params,
    }).then((res) => res);
  },
  // 导出(通用)并生成记录
  async httpClient(params) {
    return await axios_export({
      path: "/common/v1/help/httpClient",
      params,
    }).then((res) => res);
  },
  // 导出(通用)并生成记录
  async exportExcelToRecord(params) {
    return await axios_export({
      path: "/v3/admin/poi/exportExcelToRecord",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导出(通用)
  async exportExcelByUrl(params) {
    return await axios_export({
      path: "/v3/admin/poi/exportExcelByUrl",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导出(通用)并生成url
  async exportExcelToUrl(params) {
    return await axios_export({
      path: "/v3/admin/poi/exportExcelToUrl",
      params,
      headerType,
    }).then((res) => res);
  },

  // 根据字典类型获取字典值下拉列表
  async wtl_getConfDictValDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/getConfDictValDownList",
      params,
      method,
    }).then((res) => res);
  },
  async wtl_getConfDictValDownListV5(type) {
    const params = {
      number: "select_dict_by_type",
      conditionReqs: [
        {
          conditonKey: "type",
          conditonVal: type,
        },
      ],
    };
    return await axios_requer({
      path: "/v1/common/query/runReport",
      params,
      headerType,
    }).then((res) => res.data.result.datas);
  },
  // 根据对象类型获取对象的下拉列表
  async wtl_getObjectUserDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/getObjectUserDownList",
      params,
      method,
    }).then((res) => res);
  },
  // 登录
  async wtl_oauthAdmin(params) {
    return await axios_requer({
      path: "/v1/admin/oauth/oauthAdmin",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 员工列表
  async wtl_getEmployeeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/employee/getEmployeeList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建员工
  async wtl_addEmployee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/employee/addEmployee",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 新建组织架构
  async wtl_addDept(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/addDept",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 部门类型下拉列表
  async wtl_getDeptTypeDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/getDeptTypeDownList",
      params,
      method,
    }).then((res) => res);
  },
  // 组织架构维护左边导航栏()
  async wtl_getLeftDeptList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/getLeftDeptList",
      params,
      method,
    }).then((res) => res);
  },
  // 组织架构列表
  async wtl_getDeptList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/getDeptList",
      params,
      method,
    }).then((res) => res);
  },
  // 删除组织架构
  async wtl_delDept(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/delDept",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用组织架构
  async wtl_stopDept(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/stopDept",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 启用组织架构
  async wtl_startDept(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/startDept",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改组织架构
  async wtl_udpateDept(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/udpateDept",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 字典类型列表(左边)
  async wtl_getConfDictTypeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/getConfDictTypeList",
      params,
      method,
    }).then((res) => res);
  },
  // 字典列表(右边)
  async wtl_getConfDictList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/getConfDictList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建字典
  async wtl_addConfDict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/addConfDict",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改字典
  async wtl_udpateConfDict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/udpateConfDict",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 删除字典
  async wtl_delConfDict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/delConfDict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 启用字典
  async wtl_startConfDict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/startConfDict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用字典
  async wtl_stopConfDict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/stopConfDict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 地区列表
  async wtl_getDistrictList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/getDistrictList",
      params,
      method,
    }).then((res) => res);
  },
  // 地区列表
  async wtl_getLeftDistrictList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/getLeftDistrictList",
      params,
      method,
    }).then((res) => res);
  },
  // 修改地区
  async wtl_gudpateDistrict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/udpateDistrict",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改地区
  async wtl_addDistrict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/addDistrict",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 启用地区
  async wtl_startDistrict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/startDistrict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用地区
  async wtl_stopDistrict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/stopDistrict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除地区
  async wtl_delDistrict(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/delDistrict",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取组织架构详情
  async wtl_getDeptDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dept/getDeptDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 获取地区详情
  async wtl_getDistrictDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/district/getDistrictDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 货物品类类型列表
  async wtl_getCategoryTypeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/getCategoryTypeList",
      params,
      method,
    }).then((res) => res);
  },
  // 货物品类类型维护左边导航栏
  async wtl_getLeftCategoryTypeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/getLeftCategoryTypeList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取冲突货物品类
  async wtl_getConflictCategoryTypeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/getConflictCategoryTypeList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建货物品类类型
  async wtl_addCategoryType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/addCategoryType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除货物品类类型
  async wtl_delCategoryType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/delCategoryType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改货物品类类型
  async wtl_udpateCategoryType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/udpateCategoryType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 启用货物品类类型
  async wtl_startCategoryType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/startCategoryType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用货物品类类型
  async wtl_stopCategoryType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/type/stopCategoryType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 新建货物品类
  async wtl_addCategory(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/addCategory",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改货物品类
  async wtl_udpateCategory(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/udpateCategory",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 启用货物品类
  async wtl_startCategory(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/startCategory",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除货物品类
  async wtl_delCategory(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/delCategory",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用货物品类
  async wtl_stopCategory(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/stopCategory",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 货物品类列表
  async wtl_getCategoryList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/category/getCategoryList",
      params,
      method,
    }).then((res) => res);
  },
  // 账号列表
  async wtl_getAccountList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/getAccountList",
      params,
      method,
    }).then((res) => res);
  },
  // 角色管理列表
  async wtl_roleList(params) {
    return await axios_requer({
      path: "/v1/admin/role/roleList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取账号详情
  async wtl_getAccountDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/getAccountDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 新建账号
  async wtl_addAccount(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/addAccount",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改账号
  async wtl_udpateAccount(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/udpateAccount",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 添加角色
  async wtl_addRole(params) {
    return await axios_requer({
      path: "/v1/admin/role/addRole",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改角色
  async wtl_updateRole(params) {
    return await axios_requer({
      path: "/v1/admin/role/updateRole",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 删除角色
  async wtl_deleteRole(params) {
    return await axios_requer({
      path: "/v1/admin/role/deleteRole",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 角色详情
  async wtl_roleDetail(params) {
    return await axios_requer({
      path: "/v1/admin/role/roleDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 用户角色菜单(当前登录用户全部菜单和权限)
  async wtl_getLoginUserRoleMenuPerList(params) {
    return await axios_requer({
      path: "/v2/admin/getLoginUserRoleMenuPerList",
      params,
      method,
    }).then((res) => res);
  },
  // 角色菜单和权限列表
  async wtl_getRoleMenuPermissionList(params) {
    return await axios_requer({
      path: "/v2/admin/role/getRoleMenuPermissionList",
      params,
      method,
    }).then((res) => res);
  },
  // 保存角色的菜单
  async wtl_saveRoleMenu(params) {
    return await axios_requer({
      path: "/v1/admin/role/saveRoleMenu",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 保存角色的权限
  async wtl_saveRolePermission(params) {
    return await axios_requer({
      path: "/v2/admin/role/saveRolePermission",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除账号
  async wtl_delAccount(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/delAccount",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 启用账号
  async wtl_startAccount(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/startAccount",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 禁用账号
  async wtl_stopAccount(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/stopAccount",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 根据用户id获取用户的菜单权限列表
  async wtl_getUserRoleMenuPerList(params) {
    return await axios_requer({
      path: "/v2/admin/getUserRoleMenuPerList",
      params,
      method,
    }).then((res) => res);
  },
  // 保存单个用户的菜单权限
  async wtl_savaUserPermission(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/savaUserPermission",
      // path: "/v2/admin/savaUserPermission",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改员工
  async wtl_udpateEmployee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/employee/udpateEmployee",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 删除员工
  async wtl_delEmployee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/employee/delEmployee",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 新建运单
  async wtl_addWaybill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/addWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 运单列表(综合查询)
  async wtl_getWaybillList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillList",
      // path: "/admin/v3/tms/waybill/getWaybillList",
      params,
      method,
    }).then((res) => res);
  },
  // 收-发货人地址
  async wtl_getCustomerAddrList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/customer/getCustomerAddrList",
      params,
      method,
    }).then((res) => res);
  },
  // 客户档案列表
  async wtl_getCustomerList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/customer/getCustomerList",
      params,
      method,
    }).then((res) => res);
  },
  // 货物列表
  async wtl_getItemList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/getItemList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建货物
  async wtl_addItem(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/addItem",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改货物
  async wtl_udpateItem(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/udpateItem",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 删除货物
  async wtl_delItem(params) {
    return await axios_requer({
      path: "/admin/v3/tms/item/delItem",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // app版本列表
  async wtl_getAppVersionList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/appversion/getAppVersionList",
      params,
      method,
    }).then((res) => res);
  },
  // 费型类型下拉列表
  // async itemCategorChoose(params) {
  //     return await axios_requer({
  //         path: "/admin/v3/tms/itemservice/itemCategorChoose",
  //         params,
  //         method
  //     }).then(res => res);
  // },
  // 根据类别和费项类型获取费项
  async wtl_getCategoryServiceList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/itemservice/getCategoryServiceList",
      params,
      method,
    }).then((res) => res);
  },
  // 自动生成运单号
  async wtl_createBillNumber(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/createBillNumber",
      // path: "/admin/v3/tms/waybill/createBillNumber",
      params,
      method,
    }).then((res) => res);
  },
  // 运单详情
  async wtl_getWaybillDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillDetail",
      // path: "/admin/v3/tms/waybill/getWaybillDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 运单号列表
  async wtl_getWaybillNumberList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillNumberList",
      // path: "/admin/v3/tms/waybill/getWaybillNumberList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单财务信息
  async wtl_getWaybillFinance(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillFinance",
      // path: "/admin/v3/tms/waybill/getWaybillFinance",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单附件
  async wtl_getWaybillFiles(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillFiles",
      // path: "/admin/v3/tms/waybill/getWaybillFiles",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单财务信息附件
  async wtl_getFileList(params) {
    return await axios_requer({
      path: "/base/saas/v1/file/getFileList",
      params,
      method,
    }).then((res) => res);
  },
  // 作废运单
  async wtl_cancelWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/cancelWaybill",
      // path: "/admin/v3/tms/waybill/cancelWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除运单
  async wtl_delWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/delWaybill",
      // path: "/admin/v3/tms/waybill/delWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改运单
  async wtl_updateWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybill",
      // path: "/admin/v3/tms/waybill/updateWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取运单操作日志
  async wtl_getWaybillOperateLog(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillOperateLog",
      // path: "/admin/v3/tms/waybill/getWaybillOperateLog",
      params,
      method,
    }).then((res) => res);
  },
  // 根据文件名获取文件路径
  async wtl_getFileUrl(params) {
    return await axios_requer({
      path: "/base/saas/v1/file/getFileUrl",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单出入库记录
  async wtl_getWaybillStockRecord(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillStockRecord",
      // path: "/admin/v3/tms/waybill/getWaybillStockRecord",
      params,
      method,
    }).then((res) => res);
  },
  // 运单运输轨迹
  async wtl_getWaybillTrack(params) {
    return await axios_requer({
      // path: "/admin/v3/tms/waybill/getWaybillTrack",
      path: "/admin/v4/tms/waybill/getWaybillTrack",
      params,
      method,
    }).then((res) => res);
  },
  // 运单运输轨迹
  async getBillKfTrackRecordListV2(params) {
    return await axios_requer({
      path: "/v2/admin/bill/kf/track/record/getBillKfTrackRecordListV2",
      params,
      method,
    }).then((res) => res);
  },
  // 运单运输轨迹
  async addBillKfTrackRecordV2(params) {
    return await axios_requer({
      path: "/v2/admin/bill/kf/track/record/addBillKfTrackRecordV2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 上传运单附件
  async wtl_uploadWaybillFile(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/uploadWaybillFile",
      // path: "/admin/v3/tms/waybill/uploadWaybillFile",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 确认签收
  async wtl_signforWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/signforWaybill",
      // path: "/admin/v3/tms/waybill/signforWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 运单过账
  async wtl_postingWaybill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/postingWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 运单反过账
  async wtl_postingBackWaybill(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/postingBackWaybill",
      // path: "/admin/v3/tms/waybill/postingBackWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 终止运单
  async wtl_stopWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/stopWaybill",
      // path: "/admin/v3/tms/waybill/stopWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 拆单
  async wtl_splitWaybill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/splitWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 终止运单
  async getBillKfTrackRecordFileV2(params) {
    return await axios_requer({
      path: "/v2/admin/bill/kf/track/record/getBillKfTrackRecordFileV2",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单的货物信息
  async wtl_getWaybillItems(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillItems",
      // path: "/admin/v3/tms/waybill/getWaybillItems",
      params,
      method,
    }).then((res) => res);
  },
  // 运单合单
  async wtl_closeWaybill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/closeWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 运输规划列表
  async wtl_getTaskList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getTaskList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取待规划提货地址列表
  async wtl_getWaybillTakeAddrList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getWaybillTakeAddrList",
      params,
      method,
    }).then((res) => res);
  },
  // 登录页logo标题
  async getAdminLoginPic(params) {
    return await axios_requer({
      path: "/common/v1/tenant/getAdminLoginPic",
      params,
      method,
    }).then((res) => res);
  },
  // 左上角logo
  async getLogo(params) {
    return await axios_requer({
      path: "/common/v1/tenant/getLogo",
      params,
      method,
    }).then((res) => res);
  },
  // 获取待规划运单列表
  async wtl_getWaybillToDoTaskList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getWaybillToDoTaskList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取账号详情
  async personalInfo(params) {
    return await axios_requer({
      path: "/v1/admin/personal/personalInfo",
      params,
      method,
    }).then((res) => res);
  },

  // 生成任务 (新建调度计划)
  async wtl_createTask(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/createTask",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 装货确认
  async wtl_loadSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/loadSure",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 卸货确认
  async wtl_unloadSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/unloadSure",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 删除任务
  async wtl_delTask(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/delTask",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 改单号
  async wtl_updateWaybillNumber(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybillNumber",
      // path: "/admin/v3/tms/waybill/updateWaybillNumber",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 初始化发车批次
  async wtl_initDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/initDispatch",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 获取未调度的任务列表
  async wtl_getNoDispatchTaskList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getNoDispatchTaskList",
      params,
      headerType,
    }).then((res) => res);
  },
  // 根据提货地址id获取货物信息
  async wtl_getWaybillAddrItems(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getWaybillAddrItems",
      params,
      method,
    }).then((res) => res);
  },
  // 保存发车批次的任务
  async wtl_saveDispatchTask(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/saveDispatchTask",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取发车批次对应的装卸信息(路线调整)
  async wtl_getDispatchAddrList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchAddrList",
      params,
      method,
    }).then((res) => res);
  },
  // 调度列表
  async wtl_getDispatchList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取发车批次财务信息
  async wtl_getDispatchFinance(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchFinance",
      params,
      method,
    }).then((res) => res);
  },
  // 保存路径调整
  async wtl_saveDispatchRoute(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/saveDispatchRoute",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 保存发车批次财务信息
  async wtl_saveDispatchFinance(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/saveDispatchFinance",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取发车批次的任务列表
  async wtl_getDispatchTaskList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/getDispatchTaskList",
      // path: "/admin/v3/tms/dispatch/getDispatchTaskList",
      params,
      method,
    }).then((res) => res);
  },
  // 装货到车
  async wtl_arrivalLoad(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/arrivalLoad",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 卸货到车
  async wtl_arrivalUnload(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/arrivalUnload",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 安排司机
  async wtl_arrangeDriver(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/arrangeDriver",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 获取发车批次车辆信息
  async wtl_getDispatchCarInfo(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchCarInfo",
      params,
      method,
    }).then((res) => res);
  },
  // 取消装货
  async wtl_cancelLoadSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/cancelLoadSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消卸货
  async wtl_cancelunloadSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/cancelunloadSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消装货到车
  async cancelArrivalLoad(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/cancelArrivalLoad",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消卸货到车
  async cancelArrivalUnload(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/cancelArrivalUnload",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 调度确认
  async dispatchSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/dispatchSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消调度
  async cancelDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/cancelDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 出车确认
  async wtl_startCar(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/startCar",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 出车完成
  async wtl_endCar(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/endCar",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 确认接单
  async wtl_receiveOrder(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/receiveOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取发车批次出车确认信息
  async wtl_getDispatchStartCarInfo(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchStartCarInfo",
      params,
      method,
    }).then((res) => res);
  },
  // 获取发车批次操作日志
  async wtl_getDispatchOperateLog(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchOperateLog",
      params,
      method,
    }).then((res) => res);
  },
  // 退单
  async wtl_chargeback(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/chargeback",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 外发到站
  async wtl_outgoingStation(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/outgoingStation",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 入库确认
  async wtl_inStockSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/stock/inStockSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 出库确认
  async wtl_outStockSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/stock/outStockSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 个人信息
  async wtl_personalInfo(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/personalInfo",
      params,
      method,
      istips: !params || params.istips !== false
    }).then((res) => res);
  },
  // 根据发车批次号获取运单信息
  async wtl_getWaybillByDispatchNumber(params) {
    return await axios_requer({
      path: "/admin/v3/tms/stock/getWaybillByDispatchNumber",
      params,
      method,
    }).then((res) => res);
  },
  // 获取出入库记录
  async wtl_getStockRecord(params) {
    return await axios_requer({
      path: "/admin/v3/tms/stock/getStockRecord",
      params,
      method,
    }).then((res) => res);
  },
  // 获取运单提货地址
  async wtl_getWaybillTakeAddr(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillTakeAddr",
      // path: "/admin/v3/tms/waybill/getWaybillTakeAddr",
      params,
      method,
    }).then((res) => res);
  },
  // 回单列表
  async wtl_getRnorderList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/getRnorderList",
      params,
      method,
    }).then((res) => res);
  },
  // 收回确认
  async wtl_returnSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/returnSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消收回确认
  async wtl_cancelReturnSure(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/cancelReturnSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 返回客户
  async wtl_returnCustomer(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/returnCustomer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 调拨发出
  async wtl_allocationSend(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/allocationSend",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 调拨接收
  async wtl_allocationReceive(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/allocationReceive",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取调拨记录
  async wtl_getAallocationRecordList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/getAallocationRecordList",
      params,
      method,
    }).then((res) => res);
  },
  // 上传回单图片
  async wtl_uploadRnorderFile(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/uploadRnorderFile",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取回单图片
  async wtl_getRnorderFileList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/getRnorderFileList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取回单收回图片
  async wtl_getRnorderRnFileList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/rnorder/getRnorderRnFileList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建外发单
  async wtl_addOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/addOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 外发单列表
  async wtl_getOutgoingBillList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/getOutgoingBillList",
      params,
      method,
    }).then((res) => res);
  },
  // 根据任务id获取货物信息
  async wtl_getTaskItems(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getTaskItems",
      params,
      method,
    }).then((res) => res);
  },
  // 获取外发单详情
  async wtl_getOutgoingBillDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/getOutgoingBillDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 取消过账
  async wtl_cancelPosting(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/cancelPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除外发单
  async wtl_delOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/delOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 过账外发单
  async wtl_postingOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/postingOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改外发单
  async wtl_updateOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/outgoing/updateOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 异常列表
  async wtl_getExceptionList(params) {
    return await axios_requer({
      path: "/admin/v3/exception/getExceptionList",
      params,
      method,
    }).then((res) => res);
  },
  // 新建异常
  async wtl_addException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/addException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 赔款过账
  async wtl_claimPosting(params) {
    return await axios_requer({
      path: "/admin/v3/exception/claimPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 赔款反过账
  async wtl_claimBackPosting(params) {
    return await axios_requer({
      path: "/admin/v3/exception/claimBackPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 异常完成
  async wtl_completeException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/completeException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 责任核定反过账
  async wtl_dutyBackPosting(params) {
    return await axios_requer({
      path: "/admin/v3/exception/dutyBackPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取异常详情-跟进记录
  async wtl_getExceptionHandelRecord(params) {
    return await axios_requer({
      path: "/admin/v3/exception/getExceptionHandelRecord",
      params,
      method,
    }).then((res) => res);
  },
  // 获取异常详情-异常信息
  async wtl_getExceptionDetail(params) {
    return await axios_requer({
      path: "/admin/v3/exception/getExceptionDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 跟进异常
  async wtl_handelException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/handelException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 责任核定
  async wtl_dutyException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/dutyException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 退单审核列表
  async wtl_getChargebackList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/chargeback/getChargebackList",
      params,
      method,
    }).then((res) => res);
  },
  // 退单审核
  async wtl_examineChargeback(params) {
    return await axios_requer({
      path: "/admin/v3/tms/chargeback/examineChargeback",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改车型
  async wtl_updateCarType(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/updateCarType",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 获取装卸单列表
  async wtl_getHandlingOrderList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/getHandlingOrderList",
      params,
      method,
    }).then((res) => res);
  },

  // 新增装卸单
  async wtl_addHandlingOrder(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/addHandlingOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 装卸单过账
  async wtl_postingHandlingOrder(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/postingHandlingOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 装卸单反过账
  async wtl_unPostingHandlingOrder(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/unPostingHandlingOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改装卸单
  async wtl_updateHandlingOrder(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/updateHandlingOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 送货通知列表
  async wtl_getDeliveryNoticeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/delivery/notice/getDeliveryNoticeList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取装卸单详情
  async wtl_getHandlingOrderDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/handle/order/getHandlingOrderDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 发车批次过账
  async wtl_postingDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/postingDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 发车批次反过账
  async wtl_unpostingDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/unpostingDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 发车合同列表
  async wtl_getDispatchContractList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/contract/getDispatchContractList",
      params,
      method,
    }).then((res) => res);
  },
  // 新增发车合同
  async wtl_addDispatchContract(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/contract/addDispatchContract",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 修改发车合同
  async wtl_updateDispatchContract(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/contract/updateDispatchContract",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 删除发车合同
  async wtl_delDispatchContract(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/contract/delDispatchContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 发车合同详情
  async wtl_getDispatchContractDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/contract/getDispatchContractDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 通知记录
  async wtl_getDeliveryNoticeRecord(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/delivery/notice/getDeliveryNoticeRecord",
      params,
      method,
    }).then((res) => res);
  },
  // 短信通知
  async wtl_smsNotice(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/delivery/notice/smsNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 电话通知
  async wtl_phoneNotice(params) {
    return await axios_requer({
      path: "/admin/v3/tms/waybill/delivery/notice/phoneNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取多个文件路径
  async getFileUrlMore(params) {
    return await axios_requer({
      path: "/base/saas/v1/file/getFileUrlMore",
      params,
      hasSing,
      headerType
    }).then((res) => res);
  },
  // 获取异常详情-责任核定
  async getExceptionDutyDetail(params) {
    return await axios_requer({
      path: "/admin/v3/exception/getExceptionDutyDetail",
      params,
      method,
    }).then((res) => res);
  },
  // 责任核定过账
  async dutyPosting(params) {
    return await axios_requer({
      path: "/admin/v3/exception/dutyPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 保存分摊车费
  async saveAllocationCarFee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/saveAllocationCarFee",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 获取发车批次车费分摊列表
  async getDispatchCarFeeList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchCarFeeList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取发车批次提成分摊列表
  async getDispatchCommissionList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/getDispatchCommissionList",
      params,
      method,
    }).then((res) => res);
  },
  // 过账分摊车费
  async postingAllocationCarFee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/postingAllocationCarFee",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 过账提成分摊
  async postingCommission(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/postingCommission",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 反过账分摊车费
  async backPostingAllocationCarFee(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/backPostingAllocationCarFee",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 反过账提成分摊
  async backPostingCommission(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/backPostingCommission",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 保存提成分摊
  async saveCommission(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/saveCommission",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除发车批次
  async delDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/delDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改交货日期
  async updateWaybillDeliveryTime(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybillDeliveryTime",
      // path: "/admin/v3/tms/waybill/updateWaybillDeliveryTime",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  //用户角色菜单(当前登录用户全部菜单和权限)
  async getLoginUserRoleMenuPerList(params) {
    return await axios_requer({
      path: "/v2/admin/getLoginUserRoleMenuPerList",
      params,
      method,
    }).then((res) => res);
  },
  //  自定义标题动态导出(默认模板)
  async dynamicExport(params) {
    return await axios_requer({
      path: "/v1/admin/poi/dynamicExport",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  模板数据导出
  async templateDataExport(params) {
    return await axios_requer({
      path: "/v1/admin/poi/templateDataExport",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  获取用户导出模板
  async getUserExportTemplate(params) {
    return await axios_requer({
      path: "/v1/admin/poi/getUserExportTemplate",
      params,
      method,
    }).then((res) => res);
  },
  //  获取账号对象的下拉列表
  async getAccountObjectDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/getAccountObjectDownList",
      params,
      method,
    }).then((res) => res);
  },
  //  修改密码
  async updatePassword(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/updatePassword",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  修改密码(修改自己)
  async updatePersonalPassword(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/updatePersonalPassword",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  收录客户地址
  async autoAddCustomerAddr(params) {
    return await axios_requer({
      path: "/admin/v3/tms/customer/autoAddCustomerAddr",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  消息通知列表
  async noticeList(params) {
    return await axios_requer({
      path: "/common/v2/notice/noticeList",
      params,
      method,
    }).then((res) => res);
  },
  async noticeListV2(params) {
    return await axios_requer({
      path: "/common/v2/notice/noticeList",
      params,
      method,
    }).then((res) => res);
  },
  //  消息通知详情
  async noticeDetail(params) {
    return await axios_requer({
      path: "/common/v2/notice/noticeDetail",
      params,
      method,
    }).then((res) => res);
  },
  //  获取未读通知数量
  async getUnreadNoticeCount(params) {
    return await axios_requer({
      path: "/v3/tms/admin/notice/getUnreadNoticeCount",
      params,
      method,
    }).then((res) => res);
  },
  //  全部已读
  async readAll(params) {
    return await axios_requer({
      path: "/v3/tms/admin/notice/readAll",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  阅读消息
  async readNotice(params) {
    return await axios_requer({
      path: "/v3/tms/admin/notice/readNotice",
      params,
      hasSing,
    }).then((res) => res);
  },

  //  新建app版本
  async addAppVersion(params) {
    return await axios_requer({
      path: "/admin/v3/tms/appversion/addAppVersion",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  修改app版本
  async udpateAppVersion(params) {
    return await axios_requer({
      path: "/admin/v3/tms/appversion/udpateAppVersion",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  删除app版本
  async delAppVersion(params) {
    return await axios_requer({
      path: "/admin/v3/tms/appversion/delAppVersion",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  导入运单,预览
  async importWaybill(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybill",
      params,
      headerType,
    }).then((res) => res);
  },
  //  导入运单(和货物同一个表)-预览
  async importWaybillV3v2(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybillV3v2",
      params,
      headerType,
    }).then((res) => res);
  },
  //  导入运单
  async importWaybillSure(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybillSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  导入运单数据校验
  async importWaybillCheck(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybillCheck",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  客户默认地址列表
  async wtl_getCustomerDefaultAddrList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/customer/getCustomerDefaultAddrList",
      params,
      method,
    }).then((res) => res);
  },
  //  保存用户导入模板
  async saveExportTemplate(params) {
    return await axios_requer({
      path: "/v1/admin/poi/saveExportTemplate",
      params,
      hasSing,
    }).then((res) => res);
  },
  //  获取司机详情
  async getDriverDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/driver/getDriverDetail",
      params,
      method,
    }).then((res) => res);
  },

  //  导入运单(和货物同一个表)
  async importWaybillSureV3v2(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybillSureV3v2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //  导入运单数据校验(和货物同一个表)
  async importWaybillCheckV3v2(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importWaybillCheckV3v2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  // 动态查询
  //  获取数据表
  async getTableList(params) {
    return await axios_requer({
      path: "/v1/devops/report/getTableList",
      params,
      method,
    }).then((res) => res);
  },
  //  获取表的字段
  async getColumnList(params) {
    return await axios_requer({
      path: "/v1/devops/report/getColumnList",
      params,
      method,
    }).then((res) => res);
  },
  //  新增报表
  async addReport(params) {
    return await axios_requer({
      path: "/v1/devops/report/addReport",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取运单的任务信息
  async getWaybillTaskList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/getWaybillTaskList",
      params,
      method,
    }).then((res) => res);
  },
  // 地理编码
  async geocode(params) {
    return await axios_requer({
      path: "/common/v1/map/geocode",
      params,
    }).then((res) => res);
  },

  //荣祥版

  // path,
  // params = {},
  // method = 'POST',  //  POST / GET
  // headerType = '',  //   json 和 "" 两种
  // isShowLoading = true,  //是否显示加载中
  // istips = true,        //是否弹窗
  // hasSing = false,      //是否有签名

  // let hasSing = true //需要签名的加上这个
  // let method = 'GET' //需要GET请求的加上这个
  // let headerType = 'json' //需要JSON格式的加上这个

  // 新建运单(荣祥)
  async addWaybill_rx(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/addWaybill",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 导入运单数据校验(荣祥)
  async importWaybillCheckV4(params) {
    return await axios_requer({
      path: "/v4/admin/poi/importWaybillCheckV4",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导入运单数据-预览(荣祥)
  async importWaybillV4(params) {
    return await axios_requer({
      path: "/v4/admin/poi/importWaybillV4",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导入运单(荣祥)
  async importWaybillSureV4(params) {
    return await axios_requer({
      path: "/v4/admin/poi/importWaybillSureV4",
      params,
      headerType,
    }).then((res) => res);
  },
  // 运单跟进备注
  async updateFollowRemark(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateFollowRemark",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  // 根据运单号获取运单id
  async getWaybillIdByNumber(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/getWaybillIdByNumber",
      params,
      method,
    }).then((res) => res);
  },
  // 获取报表列表
  async getReportList(params) {
    return await axios_requer({
      path: "/v1/common/query/getReportList",
      params,
      method,
    }).then((res) => res);
  },

  // 放货确认
  async releaseSure(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/releaseSure",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },

  // 取消放货确认
  async cancelReleaseSure(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/cancelReleaseSure",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
};
